import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({ components: {} })
export default class GiftAidCheckbox extends Vue {
    @Prop()
    label;
    @Prop({ default: false })
    autofocus;
    // Initial value property.
    @Prop({ default: null })
    value;
}
